import request from '@/utils/httpClient'
// supplierAccount/{id}/actions/defaultAccount
// 获取列表
export function getCompanyAccountList(params?: object) {
  return request({
    url: 'supplierAccount/page',
    method: 'get',
    params
  })
}

// 获取详情
export function getCompanyAccountById(id: number, editInfo: boolean) {
  return request({
    url: `supplierAccount/${id}?editInfo=${editInfo || false}`,
    method: 'get'
  })
}

// 批量删除
export function deleteCompanyAccountById(id: number) {
  return request({
    url: `supplierAccount/${id}`,
    method: 'delete'
  })
}

// 设置默认联系人
export function setDefaultAccount(id: number) {
  return request({
    url: `supplierAccount/${id}/actions/defaultAccount`,
    method: 'put'
  })
}

// 获取审批列表
export function getReviewCompanyList(params?: object) {
  return request({
    url: 'supplierAccount/review/page',
    method: 'get',
    params
  })
}

// 获取修改审批信息
export function reviewInfoById(id: number) {
  return request({
    url: `supplierAccount/review/${id}`,
    method: 'get'
  })
}

// 通过审批
export function reviewApprove(id: number, data?: object) {
  return request({
    url: `supplierAccount/${id}/actions/review/approve`,
    method: 'put',
    data
  })
}

// 通过拒绝
export function reviewReject(id: number, data?: object) {
  return request({
    url: `supplierAccount/${id}/actions/review/reject`,
    method: 'put',
    data
  })
}
